var map = {
	"./evento-16-11.jpeg": 4601,
	"./evento-alimentación.png": 8147,
	"./eventos.json": 2421,
	"./hugo.png": 8043,
	"./ing-agro-1.jpg": 8181,
	"./ing-agro-2.jpg": 3324,
	"./jornada-de-trabajo-11-09.jpeg": 8761,
	"./micro.jpg": 9783,
	"./taller-ab-1.jpg": 176,
	"./taller-ab-2.jpg": 9580,
	"./taller-ab-3.jpg": 7821,
	"./taller-alm-1.jpg": 6613,
	"./taller-alm-2.jpg": 1569,
	"./taller-ing-1.jpg": 9912,
	"./taller-ing-2.jpg": 5987,
	"./taller-ing-3.jpg": 9796,
	"./talleres.json": 7367,
	"./waldorf.jpg": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6482;